export default __webpack_public_path__ + "static/su-icons-ca8071ee99380e5e65fa8b3eec298af8.svg";